import React, { useContext, Fragment } from 'react';
import UserProvider from '../../context/UserContext';
import '../../dash.css'
import CardInfo from '../card/CardInfo'
import CardPlan from '../card/CardPlan'
import CardAccount from '../card/CardAccount'
import CardLicense from '../card/CardLicense'
import CardEmail from '../card/CardEmail'
import CardRefresh from '../card/CardRefresh'
import Footer from '../footer/Footer'

const MainDash = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user

    return(
        <div className="container">
            <div className="bold">
                <h1 className="welcome">Welcome, <span>{userData.username ? userData.username.charAt(0).toUpperCase() +userData.username.slice(1) : ''}</span></h1>
            </div>
            <div className="card-holder">
                <div className="card-wrapper">
                    <CardInfo></CardInfo>
                </div>
                <div className="card-wrapper">
                    <CardPlan></CardPlan>
                </div>
            </div> 
            
            <div className="card-holder">
                <div className="card-wrapper">
                    <Fragment>  
                        <CardLicense></CardLicense>
                    </Fragment>
                </div>
                <div className="card-wrapper">
                    <CardAccount></CardAccount>
                </div>
            </div>
            <div>
                <div className="card-wrapper">
                    <Footer></Footer>
                </div>
                
            </div>
            <div id="email" className="mail-overlay">
                <Fragment>
                    <CardEmail></CardEmail>
                </Fragment>
            </div>
            <div id="refresh" className="refresh-overlay">
                <Fragment>
                    <CardRefresh></CardRefresh>
                </Fragment>
            </div>
        </div>
    )
};

export default MainDash;
